<template>
  <img v-if="src" :src="src" :alt="alt" loading="lazy" />
</template>

<script>
export default {
  name: 'VLazyImage',
  props: {
    src: { type: String, default: '' },
    alt: { type: String, default: '' }
  }
}
</script>
